function FormSelect({ children, name, errors, onChange, value }) {
  return (
    <select name={name} value={value} onChange={onChange}>
      {children}
    </select>
  );
}

export default FormSelect;